import * as React from "react";
import { Button, DropdownMenu, MenuItem } from "react-ui";
import { MarketShoppingCartIcon } from "@skbkontur/icons";

import { track } from "../../../Internals/Metrics/MetricsProvider";

import { PaymentBannerCaption, PaymentBannerRoot } from "./PaymentBanner.styles";

interface PaymentBannerProps {
    urlOsno: string;
    urlUsn: string;
}

const METRICS_CATEGORY = "quickstart-banner";

export const PaymentBanner = (props: PaymentBannerProps) => {
    React.useEffect(() => {
        track(METRICS_CATEGORY, "banner-show", { scenario: "forms" });
    }, []);

    const handleButtonClick = () => {
        track(METRICS_CATEGORY, "pay-button-click", { scenario: "forms" });
    };

    const handleLinkClick = (event: React.SyntheticEvent<HTMLElement, Event>) => {
        track(METRICS_CATEGORY, "click_get_sno", {
            scenario: "forms",
            // @ts-ignore
            kstoreLink: event.target.href,
            // @ts-ignore
            sno: event.target.innerText.includes("ОСНО") ? "osno" : "usn",
        });
    };

    return (
        <PaymentBannerRoot data-tid={"payment-banner"}>
            <PaymentBannerCaption>Чтобы отправить отчет, оплатите Экстерн</PaymentBannerCaption>
            <DropdownMenu
                width={"100%"}
                menuWidth={"50%"}
                caption={
                    <Button
                        use="pay"
                        size={"medium"}
                        icon={<MarketShoppingCartIcon />}
                        width={"100%"}
                        onClick={handleButtonClick}>
                        Выставить счет на оплату
                    </Button>
                }>
                <MenuItem href={props.urlOsno} target={"_blank"} onClick={handleLinkClick}>
                    Для ОСНО
                </MenuItem>
                <MenuItem href={props.urlUsn} target={"_blank"} onClick={handleLinkClick}>
                    Для УСН
                </MenuItem>
            </DropdownMenu>
        </PaymentBannerRoot>
    );
};
